// reducers/feedbackReducer.js
export const feedbackReducer = (state = { feedbacks: [] }, action) => {
  switch (action.type) {
    // ── Loading states ──
    case "ALL_FEEDBACKS_REQUEST":
    case "MY_FEEDBACKS_REQUEST":
    case "CREATE_FEEDBACK_REQUEST":
    case "UPDATE_FEEDBACK_REQUEST":
    case "DELETE_FEEDBACK_REQUEST":
      return { ...state, loading: true, error: null, success: false };

    // ── Success states ──
    case "ALL_FEEDBACKS_SUCCESS":
      return { loading: false, feedbacks: action.payload };

    case "MY_FEEDBACKS_SUCCESS":
      return { loading: false, myFeedbacks: action.payload };

    case "CREATE_FEEDBACK_SUCCESS":
      return { loading: false, success: true, feedback: action.payload };

    case "UPDATE_FEEDBACK_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        feedbacks: state.feedbacks.map((f) =>
          f.id === action.payload.id ? action.payload : f,
        ),
      };

    case "DELETE_FEEDBACK_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        feedbacks: state.feedbacks.filter((f) => f.id !== action.payload),
      };

    // ── Fail states ──
    case "ALL_FEEDBACKS_FAIL":
    case "MY_FEEDBACKS_FAIL":
    case "CREATE_FEEDBACK_FAIL":
    case "UPDATE_FEEDBACK_FAIL":
    case "DELETE_FEEDBACK_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
